import APIClass from "./apis";
import { ApiError } from "./apis/createAPISlice";
import type { ApiResult } from "./apis/createAPISlice";
import createAPIClient from "./client/APIClientCreator";
import { Configuration } from "./generated";
import { API_BASE_URL, API_SECRET_KEY } from "~/constants";

export type { ApiError };

const baseAPIClient = createAPIClient({
  secret: API_SECRET_KEY,
  baseURL: API_BASE_URL,
  baseOptions: { withCredentials: true },
});
const axiosConfig = new Configuration({
  apiKey: API_SECRET_KEY,
  basePath: API_BASE_URL,
  baseOptions: { withCredentials: true },
});
const APIInstance = new APIClass(axiosConfig, baseAPIClient.getClient());

export const isApiError = <U>(error: unknown): error is ApiError<U> =>
  error instanceof ApiError;

export const isApiResult = <T>(
  data: unknown,
): data is ApiResult<T, unknown> => {
  if (typeof data !== "object" || data == null || !("ok" in data)) {
    return false;
  }
  if (data.ok) {
    return "data" in data;
  }

  return "error" in data && data.error instanceof ApiError;
};

export const unwrapApiResult = async <T>(
  fn: Promise<ApiResult<T, unknown>>,
): Promise<T> => {
  const result = await fn;
  if (result.ok) {
    return result.data;
  }
  throw result.error;
};

const appServer = {
  setLanguage: baseAPIClient.setLanguage,
  setAccessToken: (token: string | null) => {
    axiosConfig.accessToken = token ?? undefined;
  },
  addOnAPIErrorListener: baseAPIClient.addOnAPIErrorListener,
  addOnAPIResponseListener: baseAPIClient.addOnAPIResponseListener,
  getBaseAPIClient: () => baseAPIClient,
  getConfig: () => axiosConfig,
  fetch: baseAPIClient.fetch,
};

export type { ApiResult };
export { appServer };
const API = APIInstance.getApis();
export default API;
